module.exports = _;


//////////////////
// WEBPACK FOOTER
// external "_"
// module id = 1
// module chunks = 0